// removed by extract-text-webpack-plugin
module.exports = {"cwShellLeftNavLink":"CwShellLeftNavLink-cwShellLeftNavLink","cwShellLeftNavButtonLabel":"CwShellLeftNavLink-cwShellLeftNavButtonLabel","cwShellLeftNavLinkIcon":"CwShellLeftNavLink-cwShellLeftNavLinkIcon","active":"CwShellLeftNavLink-active","cwShellLeftNavSubLinkContainer":"CwShellLeftNavLink-cwShellLeftNavSubLinkContainer"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwshellleftnav/cwshellleftnavlink/CwShellLeftNavLink.scss
// module id = 388
// module chunks = 0